import React, { useState } from 'react';
import LogoYoumo from '../c-logosvg/youmo';

const Youmo = (props) => {
  const [defaultLanguage, setDefaultLanguage] = useState('*');

  const handleChange = (e) => {
    setDefaultLanguage(e.target.value);
  };

  const handleSubmit = (e) => {
    if (defaultLanguage === '*') {
      e.preventDefault();
    }
  };

  const { LanguagePicker, Description, Button } = props;
  if (!LanguagePicker || !LanguagePicker.Options) return null;

  return (
    <div className="c-intro-content__item c-youmo">
      <div className="c-intro-content__item__container">
        <div className="c-entry-lang__content-container">
          <div className="c-entry-lang__content-valign">
            <div className="c-entry-lang__content">
              <div className="c-entry-lang__logo">
                <LogoYoumo link={false} />
              </div>
              {Description && (
                <h3 className="c-entry-lang__heading">{Description}</h3>
              )}
              <form
                className="c-entry-lang__form"
                onSubmit={(e) => handleSubmit(e)}
                action={LanguagePicker.Action}
                method="get"
              >
                <fieldset>
                  <legend className="show-for-sr">{Description}</legend>
                  <div className="c-entry-lang__select-container">
                    <div className="c-entry-lang__select">
                      <label htmlFor="youmo-language" className="show-for-sr">
                        {LanguagePicker.Label}
                      </label>
                      <select
                        name="lang"
                        onChange={(e) => handleChange(e)}
                        id="youmo-language"
                        value={defaultLanguage}
                      >
                        {LanguagePicker.Options.map((lang, key) => (
                          <option key={key} value={lang.Value}>
                            {lang.Label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <button className="c-entry-lang__button" type="submit">
                      {Button.Label}
                    </button>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Youmo;
